module.exports = __webpack_public_path__ + "img/bg-diferencial.5cdd6e22.png";